import React, { Component } from "react";
// import moment from "moment-timezone";
// import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import "react-calendar/dist/Calendar.css";
import { GetDashboard_Url } from "../../../provider/ServiceUrl";
import store from "../../../redux/store";
import FetchServerData from "../../../provider/FetchServerData";
import Tooltip from "@material-ui/core/Tooltip";
// import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
// import Utils from "../../../provider/Utils";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { createTheme } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/date-fns";
import { Autocomplete, Menu } from "@mui/material";
// import ReactApexChart from "react-apexcharts";
import { Buffer } from "buffer";
import ClearIcon from "@mui/icons-material/Clear";
import ReactApexCharts from "react-apexcharts";
import MaterialTable from "material-table";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import Utils from "../../../provider/Utils";
import DeleteButton from "../buttons/DeleteButton";
import _ from "lodash";
import Pagination from "../pagination/Pagination";
import PaymentShortLinkDialog from "../shortLink/PaymentShortLinkDialog";
import UiUtils from "../../../provider/UiUtils";
import PtsAlert from "../ptsAlert/PtsAlert";
import moment from "moment";
import "./Dashboard.css";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import GoalRaisedAmountBar from "./GoalRaisedAmountBar";
import HistoryForMessageDialog from "./HistoryForMessageDialog";
import TextResponseDialog from "./TextResponseDialog";

const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#008181",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: "white",
        color: "#005476",
      },
    },
  },
});
class Dashboard extends Component {
  header = store.getState().header.header;
  yearList = store.getState().staticData.yearList;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  tollfreeNumber = store.getState().appUserData.tollfreeNumber;
  accountSettings = store.getState().accountSetting?.accountSetting;
  breadCrumb = [{ pageid: "", uiname: "Insights" }];

  constructor(props) {
    super(props);
    this.state = {
      message: null,
      defaultMessageActivity: { id: null, messagename: "All", isPledge: true },
      messageActivity: { id: null, messagename: "All", isPledge: true },
      messageList: [],
      messageActivityList: [],
      render: false,
      searchText: "",
      initialPage: 0,
      pageSize: 20,
      startDate: null,
      endDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      focusedInput: null,
      isPickerVisible: false,
      isFilterApplied: false,
      month: new Date().toLocaleString("default", { month: "short" }),
      monthList: Utils.getMonthList(),
      yearList: [],
      shortLinkList: [],
      messageWiseClickCount: [],
      contactSeries: null,
      contactOptions: null,
      amountSeries: null,
      amountOptions: null,
      dailyMessageSeries: null,
      dailyMessageOptions: null,
      isPickerOpen: false,
      outboundSuccessCount: 0,
      outboundFailCount: 0,
      inboundReplyCount: 0,
      outboundTotalCount: 0,
      paymentLinkClickCount: 0,
      clickCount: 0,
      goalAmount: 0,
      raisedAmount: 0,
      hasPaymentLink: false,
      isPledge: false,
      open: false,
      selectedRange: "30",
      selectedLabel: "Month",
    };
    this.getDashboardDetails(this.state.pageNo, this.state.pageSize);
    this.getDailyStat(
      this.state.messageActivity,
      this.state.startDate,
      this.state.endDate
    );
    this.debouncedSearch = _.debounce(this.getDashboardDetails, 800);
  }

  getDashboardDetails(pageNo, pageSize) {
    const postObject = {
      header: this.header,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
      eventId: this.businessDomainId,
    };

    FetchServerData.callPostService(GetDashboard_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let contactStats = output.data.contactStats;
          let shortLinkList = output.data.shortLinkList;
          let messageList = output.data.messageList;
          let messageStat = output.data.messageStat;
          let messageWiseClickCount = output.data.clickCountList;
          let smsCredits = output.data.smsCredits;
          let page = output.data.page;
          let contactLabels = [];
          let contactValue = [];

          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            if (smsCredits !== null) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCredits)
              );
            }
          } else {
            if (smsCredits !== null) {
              store.dispatch(AppUserDataAction.setUsage(smsCredits));
            }
          }
          for (let i = 0; i < contactStats.length; i++) {
            if (contactStats[i] !== null) {
              contactLabels.push(contactStats[i]?.status);
              contactValue.push(contactStats[i]?.count);
            }
          }

          let isPaging = false;
          let isMessagePaging = false;
          if (shortLinkList?.length > 10) {
            isPaging = true;
          }
          if (messageWiseClickCount.length > 10) {
            isMessagePaging = true;
          }
          for (let i = 0; i < shortLinkList?.length; i++) {
            shortLinkList[i].createdon = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(shortLinkList[i].createdon) : Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }

          for (let i = 0; i < messageWiseClickCount.length; i++) {
            messageWiseClickCount[i].messageCreateOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(messageWiseClickCount[i].messageCreateOn) : Utils.getUtcToLocal(
              messageWiseClickCount[i].messageCreateOn
            );
          }

          let messageActivityList = [
            { messageId: null, messagename: "All", isPledge: true },
            ...messageList,
          ];
          this.setState({
            render: true,
            isPickerOpen: false,
            messageList: messageList,
            messageActivityList: messageActivityList,
            message: messageStat?.message,
            isPaging: isPaging,
            isMessagePaging: isMessagePaging,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            startDate: output.data.startDate,
            endDate: output.data.endDate,
            shortLinkList: shortLinkList,
            messageWiseClickCount: messageWiseClickCount,
            contactSeries: contactValue,
            contactOptions: {
              colors: ["#7ed23a", "#6ad4ff", "#ee301c", "#ffa458"],
              labels: ["Opt-ins", "Inactives", "Opt-outs", "Invalid numbers"],
              legend: {
                position: "right",
                horizontalAlign: "left",
                markers: {
                  shape: "square"
                },
                itemMargin: {
                  vertical: 8
                },
                formatter: function (seriesName, opts) {
                  const value = opts.w.globals.series[opts.seriesIndex];
                  const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);

                  const safeValue = isNaN(value) || value == null ? 0 : value;
                  const percentage = total > 0 ? ((safeValue / total) * 100).toFixed(2) : 0;

                  return `
      <span class="custom-legend-row">
        <span class="legend-label ps-2">${seriesName}</span>
        <span class="legend-value">${percentage}%</span>
      </span>
    `;
                },
                labels: {
                  useSeriesColors: true
                }
              },
              dataLabels: {
                formatter: function (val, opts) {
                  let value = opts.w.globals.series[opts.seriesIndex];

                  if (isNaN(value) || value == null) value = 0;

                  return Number(value).toLocaleString();
                },
              },
              tooltip: {
                y: {
                  formatter: function (value, opts) {
                    const total = opts.globals.seriesTotals.reduce(
                      (a, b) => a + b,
                      0
                    );

                    if (isNaN(value) || value == null) value = 0;

                    const percent =
                      total > 0 ? ((value / total) * 100).toFixed(1) : 0;

                    return value.toLocaleString() + " (" + percent + "%)";
                  },
                },
              },

              chart: {
                type: "pie",
              },

              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200,
                    },
                    legend: {
                      position: "bottom",
                    },
                  },
                },
              ],
            },
            messageStat: messageStat,
            outboundSuccessCount: messageStat?.outboundSuccessCount,
            outboundFailCount: messageStat?.outboundFailCount,
            outboundTotalCount: messageStat?.outboundTotalCount,
            inboundReplyCount: messageStat?.inboundReplyCount,
            paymentLinkClickCount: messageStat?.paymentLinkClickCount,
            hasPaymentLink: messageStat?.hasPaymentLink,
            clickCount: messageStat?.clickCount,
            goalAmount: messageStat?.goalAmount,
            raisedAmount: messageStat?.raisedAmount,
            isPledge: messageStat?.isPledge,
          });
        } else {
        }
      }
    );
  }
  getMessageStat(selectedMessage) {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
      messageId: selectedMessage?.id,
    };

    FetchServerData.callPostService(
      "/dashboardms/getMessageStat",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let messageStat = output.data.messageStat;

        this.setState({
          render: true,
          message: messageStat?.message,
          messageStat: messageStat,
          outboundSuccessCount: messageStat?.outboundSuccessCount,
          outboundFailCount: messageStat?.outboundFailCount,
          outboundTotalCount: messageStat?.outboundTotalCount,
          inboundReplyCount: messageStat?.inboundReplyCount,
          paymentLinkClickCount: messageStat?.paymentLinkClickCount,
          hasPaymentLink: messageStat?.hasPaymentLink,
          clickCount: messageStat?.clickCount,
          goalAmount: messageStat?.goalAmount,
          raisedAmount: messageStat?.raisedAmount,
          isPledge: messageStat?.isPledge,
        });
      } else {
      }
    });
  }
  getDailyStat(messageActivity, startDate, endDate, numberOfDays) {
    const postObject = {
      header: this.header,
      startDate: startDate,
      endDate: endDate,
      eventId: this.businessDomainId,
      messageId: messageActivity?.id,
      numberOfDays: numberOfDays,
    };

    FetchServerData.callPostService(
      "/dashboardms/getDailyStat",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let dailyMessageStat = output.data.dailyMessageStat;
        let messageCountStatList = dailyMessageStat?.messageCountStatList;
        let messageActivity = dailyMessageStat?.message;
        let dailyMessageLabels = [];
        let dailySentMessageValue = [];
        let dailyFailMessageValue = [];
        let dailyOutboundMessageValue = [];
        let dailyInboundMessageValue = [];
        let dailyPaymentLinkClickValue = [];

        for (let i = 0; i < messageCountStatList.length; i++) {
          dailyMessageLabels.push(
            new Date(messageCountStatList[i]?.createdon).getTime()
          );
          dailySentMessageValue.push(
            messageCountStatList[i]?.outboundSuccessCount
          );
          dailyFailMessageValue.push(
            messageCountStatList[i]?.outboundFailCount
          );
          dailyOutboundMessageValue.push(
            messageCountStatList[i]?.outboundTotalCount
          );
          dailyInboundMessageValue.push(messageCountStatList[i]?.inboundCount);
          dailyPaymentLinkClickValue.push(
            messageCountStatList[i]?.paymentLinkClickCount
          );
        }
        const startDate = new Date(output.data.startDate).getTime();
        const endDate = new Date(output.data.endDate).getTime();

        let dailyMessageSeries = [
          {
            name: "Message sends",
            type: "area",
            data: dailyOutboundMessageValue.reverse(),
          },
          {
            name: "Successful sends",
            type: "area",
            data: dailySentMessageValue.reverse(),
          },
          {
            name: "Failed sends",
            type: "area",
            data: dailyFailMessageValue.reverse(),
          },
          {
            name: "Message replies",
            type: "area",
            data: dailyInboundMessageValue.reverse(),
          },
        ];

        // Show only if pledge message
        if (messageActivity?.isPledge || this.state.messageActivity?.messagename === "All") {
          dailyMessageSeries.push({
            name: "Payment link clicks",
            type: "area",
            data: dailyPaymentLinkClickValue.reverse(),
          });
        }

        const colors = messageActivity?.isPledge || this.state.messageActivity?.messagename === "All"
          ? ["#256ed9", "#42be3f", "#ee301c", "#e46019", "#e77ed5"]
          : ["#256ed9", "#42be3f", "#ee301c", "#e46019"];
        const markersDiscrete = [];

        dailyMessageSeries?.forEach((seriesItem, seriesIndex) => {
          seriesItem?.data?.forEach((value, dataPointIndex) => {
            if (value !== 0) {
              markersDiscrete.push({
                seriesIndex,
                dataPointIndex,
                size: 3,
                fillColor: colors[seriesIndex],
                strokeColor: "#ffffff",
                strokeWidth: 1,
              });
            }
          });
        });

        this.setState({
          render: true,
          open: false,
          focusedInput: null,
          isPickerOpen: false,
          defaultStartDate: output.data.startDate,
          defaultEndDate: output.data.endDate,
          defaultMessageActivity:
            messageActivity !== null
              ? messageActivity
              : { id: null, messagename: "All", isPledge: true },
          dailyMessageSeries: dailyMessageSeries,
          dailyMessageOptions: {
            colors: messageActivity?.isPledge || this.state.messageActivity?.messagename === "All"
              ? ["#256ed9", "#42be3f", "#ee301c", "#e46019", "#e77ed5"]
              : ["#256ed9", "#42be3f", "#ee301c", "#e46019"],
            chart: {
              height: 350,
              type: "area",
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "smooth",
              width: 2,
            },
            markers: {
              size: 0,
              hover: {
                size: 4,
              },
              discrete: markersDiscrete,
            },
            legend: {
              onItemHover: {
                highlightDataSeries: true,
              },
            },

            states: {
              normal: {
                filter: {
                  type: "none",
                  value: 0,
                },
              },
              hover: {
                filter: {
                  type: "darken",
                  value: 0.85,
                },
              },
              active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                  type: "none",
                },
              },
            },
            xaxis: {
              type: "datetime",
              categories: dailyMessageLabels.reverse(),
              // max: Date.now(),
              // tickAmount: 15,
              min: startDate,
              max: endDate,
              labels: {
                format: "MM/dd",
                // rotateAlways: true,
                // showDuplicates: true,
              },
              tooltip: {
                enabled: false,
              },
            },
            yaxis: {
              min: 0,
              forceNiceScale: true,
              labels: {
                formatter: function (val) {
                  return Math.round(val);
                },
              },
            },

            tooltip: {
              x: {
                show: true,
                formatter: function (value) {
                  const months = [
                    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sept", "Oct", "Nov", "Dec",
                  ];
                  const date = new Date(value);
                  const month = months[date.getMonth()];
                  const day = String(date.getDate()).padStart(2, "0");
                  const year = date.getFullYear();
                  return `${month} ${day}, ${year}`;
                },
              },

              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const date = w.config.tooltip.x.formatter(
                  w.globals.seriesX[seriesIndex][dataPointIndex]
                );

                const rows = w.globals.seriesNames
                  .map((s, i) => {
                    if (w.globals.collapsedSeriesIndices.includes(i)) return "";

                    const value = series[i]?.[dataPointIndex];
                    if (value === undefined || value === null) return "";

                    return `
          <div style="display:flex; align-items:center; padding:3px 0px;">
            <span style="
              width:10px;
              height:10px;
              border-radius:50%;
              background:${w.globals.colors[i]};
              display:inline-block;
              margin-right:6px;">
            </span>
            <span>${s}: ${value}</span>
          </div>
        `;
                  })
                  .join("");

                if (!rows) return "";

                return `
      <div style="padding:8px; font-size:13px; line-height:1.2;">
        <div style="font-weight:600; margin-bottom:5px;">${date}</div>
        ${rows}
      </div>
    `;
              },
            },
          },
        });
      } else {
      }
    });
  }
  handleTimeRangeChange = (event) => {
    const selectedRange = event.target.value;
    this.setState({ selectedRange }, () => {
      this.getDashboardDetails();
    });
  };

  deleteShortLink(data) {
    const postObject = {
      header: this.header,
      shortLink: {
        id: data.id,
      },
      page: {
        searchText: this.state.searchText,
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      },
    };
    FetchServerData.callPostService("/dashboardms/deleteShortLink", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortLinkList = output.data.shortLinkList;
          let page = output.data.page;
          let isPaging = false;
          if (shortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(shortLinkList[i].createdon) : Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            isPaging: isPaging,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            shortLinkList: shortLinkList,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  showActionButton(rowData) {
    return (
      <>
        <DeleteButton
          title={rowData.sourceLink}
          pageId="link"
          domainObject={rowData.sourceLink}
          onClick={this.deleteShortLink.bind(this, rowData)}
        />
      </>
    );
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }
  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.getDashboardDetails(currentPageIndex, pageSize);
    this.setState({
      pageNo: currentPageIndex,
    });
  }

  handleOpen = (e, data) => {
    let paginationState = store.getState().paginations.paymetShortLinkState;
    let pageSize = paginationState && paginationState.pageSize
      ? paginationState.pageSize
      : 10;
    let sortColumn = paginationState && paginationState.sortColumn
      ? this.paginationState?.sortColumn : null;
    let isAscSort = paginationState && paginationState.isAscSort
      ? this.paginationState?.isAscSort : false;

    if (
      this.paymentShortLinkDialogueRef &&
      this.paymentShortLinkDialogueRef.current
    ) {
      this.paymentShortLinkDialogueRef.current.showMsgShortLinkList(
        data?.messageId,
        0,
        pageSize,
        data.clickCount,
        sortColumn, isAscSort
      );
    }
  };
  openPaymenClickDialog = (e) => {
    let paginationState = store.getState().paginations.paymetShortLinkState;
    let pageSize = paginationState && paginationState.pageSize
      ? paginationState.pageSize
      : 10;
    let sortColumn = paginationState && paginationState.sortColumn
      ? this.paginationState?.sortColumn : null;
    let isAscSort = paginationState && paginationState.isAscSort
      ? this.paginationState?.isAscSort : false;
    if (
      this.paymentShortLinkDialogueRef &&
      this.paymentShortLinkDialogueRef.current
    ) {
      this.paymentShortLinkDialogueRef.current.showClickPaymentLinkList(
        this.state.message?.id,
        0,
        pageSize,
        this.state.clickCount, sortColumn, isAscSort
      );
    }
  };

  getCaptionText = () => {
    const { startDate, endDate, isFilterApplied } = this.state;

    if (!isFilterApplied || !startDate) return "Click to set filter";

    if (startDate && endDate) {
      return `${startDate.format("MM/DD/YYYY")} - ${endDate.format(
        "MM/DD/YYYY"
      )}`;
    }

    return startDate.format("MM/DD/YYYY");
  };

  togglePicker = (e) => {
    e.stopPropagation(); // Prevent triggering caption click
    this.setState((prev) => ({
      isPickerVisible: !prev.isPickerVisible,
      focusedInput: "startDate",
    }));
  };

  handleOpenDialog = () => {
    this.setState({ isPickerOpen: true });
  };

  handleCloseDialog = () => {
    this.setState({ isPickerOpen: false });
  };

  handleDatesChange = ({ startDate, endDate }) => {
    this.setState({
      startDate: startDate
        ? moment(startDate).startOf("day").toISOString(true)
        : null,
      endDate: endDate
        ? moment(endDate).startOf("day").toISOString(true)
        : null,
    });
  };

  renderCalendarFooter = () => {
    return (
      <div style={{ paddingBottom: "10px", textAlign: "center" }}>
        <Button
          color="primary"
          type="button"
          onClick={this.getDailyStat.bind(this)}
        >
          Apply
        </Button>
      </div>
    );
  };

  handleSubmitDateRange = () => {
    this.setState({ focusedInput: null });
  };

  handleFocusChange = (focusedInput) => {
    this.setState({ focusedInput });
  };

  formatRange = () => {
    const { startDate, endDate } = this.state;
    if (startDate && endDate) {
      return `${startDate.format("M/D/YYYY")} - ${endDate.format("M/D/YYYY")}`;
    }
    return "Click to set filter";
  };

  handleCaptionClick = () => {
    // Toggle filter applied or not
    this.setState((prev) => ({
      isFilterApplied: !prev.isFilterApplied,
      ...(prev.isFilterApplied && { startDate: null, endDate: null }),
    }));
  };

  handleSubmit = () => {
    const { startDate, endDate } = this.state;
    alert(
      `Selected Range: ${startDate?.format("MM/DD/YYYY")} - ${endDate?.format(
        "MM/DD/YYYY"
      )}`
    );
  };
  handleSelect = (ranges) => {
    this.setState({ selectionRange: ranges.selection });
  };

  handleMessageChange(selectedMessage) {
    this.setState({
      message: selectedMessage,
    });
    this.getMessageStat(selectedMessage);
  }
  handleMessageActivityChange(selectedMessage) {
    this.setState({
      messageActivity: selectedMessage,
    });
    let startDate =
      this.state.selectedRange === null ? this.state.startDate : null;
    let endDate = this.state.selectedRange === null ? this.state.endDate : null;
    this.getDailyStat(
      selectedMessage,
      startDate,
      endDate,
      this.state.selectedRange
    );
  }

  exportMessageData() {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: this.state.message?.id,
      },
    };

    FetchServerData.callPostService(
      "/csvImpExpms/exportMessageData",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let csvMessageData = output.data;
          const byteArray = new Buffer(
            csvMessageData.data.replace(/^.+base64,/, ""),
            "base64"
          );
          const outputFilename = csvMessageData.filename;
          const url = URL.createObjectURL(new Blob([byteArray]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", outputFilename);
          document.body.appendChild(link);
          link.click();
        } else {
        }
      })
      .catch((error) => { });
  }
  openHistoryForMessageDialog() {
    let paginationState = store.getState().paginations.succSendMsgStatsState;
    let pageSize = paginationState && paginationState.pageSize
      ? paginationState.pageSize
      : 20;
    let sortColumn = paginationState && paginationState.sortColumn
      ? this.paginationState?.sortColumn : null;
    let isAscSort = paginationState && paginationState.isAscSort
      ? this.paginationState?.isAscSort : false;
    if (
      this.historyForMessageDialogueRef &&
      this.historyForMessageDialogueRef.current
    ) {
      this.historyForMessageDialogueRef.current.showHistoryForMessageList(
        this.state.message,
        0,
        pageSize,
        sortColumn,
        isAscSort
      );
    }
  }
  openTextResponseDialog() {
    let paginationState = store.getState().paginations?.textResponseMsgStatsState;
    let pageSize = paginationState && paginationState.pageSize
      ? paginationState.pageSize
      : 20;
    let sortColumn = paginationState && paginationState.sortColumn
      ? this.paginationState?.sortColumn : null;
    let isAscSort = paginationState && paginationState.isAscSort
      ? this.paginationState?.isAscSort : false;
    if (this.textResponseDialogueRef && this.textResponseDialogueRef.current) {
      this.textResponseDialogueRef.current.showTextResponseList(
        this.state.message,
        0,
        pageSize,
        sortColumn,
        isAscSort
      );
    }
  }

  handleStartDateChange(date) {
    let fromDate = Date.parse(date);
    let toDate = Date.parse(this.state.endDate);
    if (this.state.endDate === null && date === null) {
      this.setState({
        startDate: date,
        errorMassage: false,
        error: false,
      });
    } else if (date === null) {
      this.setState({
        startDate: date,
        errorMassage: true,
        error: false,
      });
    } else if (fromDate > toDate) {
      this.setState({
        startDate: date,
        error: true,
        errorMassage: false,
      });
    } else {
      this.setState({
        startDate: date,
        errorMassage: false,
        error: false,
      });
    }
  }

  handleEndDateChange(date) {
    let fromDate = Date.parse(this.state.startDate);
    let toDate = Date.parse(date);

    if (this.state.startDate === null && date === null) {
      this.setState({
        endDate: date,
        errorMassage: false,
        error: false,
      });
    } else if (this.state.startDate === null) {
      this.setState({
        endDate: date,
        errorMassage: true,
        error: false,
      });
    } else if (fromDate > toDate) {
      this.setState({
        endDate: date,
        error: true,
        errorMassage: false,
      });
    } else {
      this.setState({
        endDate: date,
        errorMassage: false,
        error: false,
      });
    }
  }

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleAccountDropdownOpen = (e) => {
    this.setState({ open: true, anchorEl: e.currentTarget });
  };

  filterRecords(e) {
    let messageActivity = this.state.messageActivity;
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    this.getDailyStat(messageActivity, startDate, endDate);
    this.setState({ selectedLabel: "", selectedRange: null });
  }

  resetFilter() {
    let messageActivity = { id: null, messagename: "All", isPledge: true };
    let startDate = null;
    let endDate = null;

    this.getDailyStat(messageActivity, startDate, endDate);
  }
  handleRangeChange = (range) => {
    const selectedRange = range.value || "30";
    let messageActivity = this.state.messageActivity;
    let startDate = null;
    let endDate = null;
    this.setState({ selectedRange, selectedLabel: range.label }, () => {
      this.getDailyStat(messageActivity, startDate, endDate, selectedRange);
    });
  };

  render() {
    this.historyForMessageDialogueRef = React.createRef();
    this.textResponseDialogueRef = React.createRef();
    this.paymentShortLinkDialogueRef = React.createRef();
    const total =
      this.state.outboundSuccessCount + this.state.outboundFailCount;
    const successPercent = total
      ? (this.state.outboundSuccessCount / total) * 100
      : 0;
    const failPercent = total
      ? (this.state.outboundFailCount / total) * 100
      : 0;

    const { selectedLabel } = this.state;
    const ranges = [
      { label: "Week", value: "7" },
      { label: "Month", value: "30" },
      { label: "Quarter", value: "90" },
      { label: "Half Year", value: "180" },
      { label: "Year", value: "365" },
    ];

    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            name="Insights"
          />
          <HistoryForMessageDialog
            ref={this.historyForMessageDialogueRef}
            style={{ float: "right" }}
          />
          <TextResponseDialog
            ref={this.textResponseDialogueRef}
            style={{ float: "right" }}
          />
          <div className="row align-items-stretch">
            <div className="col-md-6 d-flex">
              <div className="card flex-fill rounded-0">
                <div className="card-body pb-3">
                  <div className="row mb-12 row d-flex justify-content-around">
                    <div className="row">
                      <div className="col-sm-6">
                        <h5 className="text-start pb-3 mt-1 cardSub-hedding">
                          Message Statistics
                        </h5>
                      </div>
                      <div className="col-sm-6">
                        <Autocomplete
                          id="size-small-outlined"
                          size="small"
                          fullWidth
                          disableClearable
                          autoComplete="off"
                          ListboxProps={{
                            className: "custom-listbox",
                          }}
                          options={this.state.messageList}
                          value={this.state.message}
                          getOptionLabel={(option) => option.messagename}
                          defaultValue={this.state.message}
                          onChange={(event, value) => {
                            this.handleMessageChange(value);
                          }}
                          inputprops={{
                            style: {
                              textTransform: "capitalize",
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                              size="small"
                              className="autoComplete"
                              required
                              title=""
                              style={{ background: "#fff" }}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="text-start" id="chart">
                      <div
                        style={{
                          padding: "0px 15px",
                          maxWidth: "100%",
                          fontSize: "small",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "32px",
                            background: "#eee",
                            borderRadius: "4px",
                            overflow: "hidden",
                            display: "flex",
                          }}
                        >
                          <Tooltip
                            title={`${successPercent?.toFixed(1)}% Success`}
                            classes={{ popper: "custom-tooltip" }}
                            arrow
                          >
                            <div
                              style={{
                                width: `${successPercent}%`,
                                height: "100%",
                                backgroundColor: "#7ed23a",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                fontSize: "12px",
                                fontWeight: "bold",
                              }}
                            >
                              {this.state.outboundSuccessCount > 0 &&
                                this.state.outboundSuccessCount}
                            </div>
                          </Tooltip>
                          <Tooltip
                            title={`${failPercent?.toFixed(1)}% Fail`}
                            classes={{ popper: "custom-tooltip" }}
                            arrow
                          >
                            <div
                              style={{
                                width: `${failPercent}%`,
                                height: "100%",
                                backgroundColor: "#ee301c",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                fontSize: "12px",
                                fontWeight: "bold",
                              }}
                            >
                              {this.state.outboundFailCount > 0 &&
                                this.state.outboundFailCount}
                            </div>
                          </Tooltip>
                        </div>
                        <div className="row mt-1">
                          <div className="col-sm-6">
                            <div className="row">
                              <label
                                className="col-sm-6"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Successful Sends:
                              </label>
                              <div className="col-sm-6" id="givbeeText">
                                <span
                                  style={{
                                    color: "#353538",
                                    fontWeight: "600",
                                  }}
                                >
                                  <span
                                    className="anchortag"
                                    style={{ cursor: "pointer" }}
                                    onClick={this.openHistoryForMessageDialog.bind(
                                      this
                                    )}
                                  >
                                    {this.state.outboundSuccessCount || 0}/
                                    {(this.state.outboundSuccessCount || 0) +
                                      (this.state.outboundFailCount || 0)}
                                  </span>
                                  {/* {" - "}
                                  {successPercent % 1 === 0
                                    ? successPercent.toFixed(0)
                                    : successPercent.toFixed(1)}
                                  % */}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6 align-self-end text-end">
                            {(this.state.outboundSuccessCount > 0 || this.state.outboundFailCount > 0) &&
                              < Button
                                id="downloadReportButton"
                                variant="contained"
                                type="button"
                                startIcon={
                                  <i
                                    className="fa fa-download"
                                    style={{ fontSize: "16px" }}
                                  ></i>
                                }
                                onClick={this.exportMessageData.bind(this)}
                              >
                                Download Report
                              </Button>
                            }
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-sm-12">
                            <div className="row" style={{ height: "32px" }}>
                              <label
                                className="col-sm-3 align-self-center"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Message Replies:
                              </label>
                              <div
                                className="col-sm-9 align-self-center"
                                id="givbeeText"
                              >
                                <span
                                  className="me-2"
                                  style={{
                                    color: "#353538",
                                    fontWeight: "600",
                                  }}
                                >
                                  <span
                                    className="anchortag"
                                    style={{ cursor: "pointer" }}
                                    onClick={this.openTextResponseDialog.bind(
                                      this
                                    )}
                                  >
                                    {this.state.inboundReplyCount || 0}
                                  </span>
                                </span>
                                {/* {this.state.inboundReplyCount > 0 && (
                                  <Tooltip
                                    title="Download Report"
                                    classes={{ popper: "custom-tooltip" }}
                                  >
                                    <DownloadForOfflineIcon
                                      style={{
                                        borderRadius: "25%",
                                        color: "#6A7B8E",
                                        fontSize: "x-large",
                                        width: "30px",
                                        minHeight: "30px",
                                        padding: "3px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => this.exportMessageData()}
                                    />
                                  </Tooltip>
                                )} */}
                              </div>
                            </div>
                            {this.state.hasPaymentLink && (
                              <div className="row">
                                <label
                                  className="col-sm-3"
                                  htmlFor="basic-default-name"
                                  id="assetFormLabel"
                                >
                                  Payment link clicks:
                                </label>
                                <div className="col-sm-9" id="givbeeText">
                                  <span
                                    style={{
                                      color: "#353538",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {this.state.clickCount}
                                  </span>
                                  {this.state.clickCount > 0 && (
                                    <span
                                      className="anchortag ps-2"
                                      target="_blank"
                                      onClick={(e) =>
                                        this.openPaymenClickDialog(e)
                                      }

                                    // href={
                                    //   this.state.companyWebsite
                                    //     ? this.state.companyWebsite
                                    //     : ""
                                    // }
                                    >
                                      view details
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mt-4">
                          <div className="col-sm-12">
                            {this.state.goalAmount > 0 && (
                              <GoalRaisedAmountBar
                                goalAmount={this.state.goalAmount}
                                raisedAmount={this.state.raisedAmount}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <div
                className={
                  Utils.getBrowserType() === "Safari"
                    ? "card flex-fill safariContactStatistics rounded-0"
                    : "card flex-fill rounded-0"
                }
              >
                <div className="card-body pb-3">
                  <div className="row mb-12 row d-flex justify-content-around">
                    <h5 className="text-start pb-3 mt-1 cardSub-hedding">Contact Statistics</h5>
                    <div className="text-start contact-statistics" id="chart">
                      {this.state.contactOptions !== null &&
                        this.state.contactSeries !== null ? (
                        <ReactApexCharts
                          options={this.state.contactOptions}
                          series={this.state.contactSeries}
                          type="pie"
                          height={180}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="card rounded-0">
                <div className="card-body">
                  <div className="row ps-3 pe-3">
                    <div className="col-sm-12">
                      <h5 className="text-start cardSub-hedding">Message Activity</h5>
                    </div>
                  </div>
                  <div className="row d-flex ps-3 pe-3">
                    <div className="col-sm-4">
                      <div className="row">
                        <div className="col-sm-12 text-align-center">
                          <ButtonGroup variant="outlined" size="small">
                            {ranges.map((range) => (
                              <button
                                key={range.value}
                                onClick={() => this.handleRangeChange(range)}
                                style={{
                                  marginRight: "5px",
                                  padding: "3px 10px",
                                  border: "1px solid #1976d2",
                                  borderRadius: "4px",
                                  backgroundColor:
                                    selectedLabel === range.label
                                      ? "#1976d2"
                                      : "transparent",
                                  color:
                                    selectedLabel === range.label
                                      ? "white"
                                      : "#333",
                                  cursor: "pointer",
                                  transition: "all 0.2s",
                                }}
                              >
                                {range.label === "Year" ? range.label : `${range.value} Days`}
                              </button>
                            ))}
                          </ButtonGroup>
                        </div>
                      </div>
                    </div>
                    <div className="filter-container col-sm-8 text-start">
                      <div className="row">
                        <div className="col-12 align-items-end pe-1">
                          <div className="row">
                            <div className="col-sm-5">
                              <div
                                className="row d-flex messageActive"
                                id="assetFormLabel"
                              >
                                <label
                                  className="col-sm-3 form-label pe-0 text-end align-self-center"
                                  htmlFor="collapsible-supplierType"
                                >
                                  Message:
                                </label>
                                <div
                                  className="col-sm-9 ps-2 dashboardMsgActivity"
                                  id="assetFormLabel"
                                >
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    autoComplete="off"
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.messageActivityList}
                                    value={this.state.messageActivity}
                                    getOptionLabel={(option) =>
                                      option.messagename
                                    }
                                    defaultValue={this.state.messageActivity}
                                    onChange={(event, value) => {
                                      this.handleMessageActivityChange(value);
                                    }}
                                    inputprops={{
                                      style: {
                                        textTransform: "capitalize",
                                      },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        required
                                        title=""
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-7 text-end p-0">
                              {this.state.message !== null ? (
                                <>
                                  {this.state.defaultStartDate !== "" &&
                                    this.state.defaultStartDate !== null && (
                                      <ValidatorForm
                                        ref="form"
                                        onSubmit={this.filterRecords.bind(this)}
                                      >
                                        <div className="row d-flex justify-content-start DateRangePicker">
                                          <div className="col-md-3 align-self-center">
                                            <label
                                              className="form-label"
                                              htmlFor="collapsible-supplierType"
                                            >
                                              Date range:
                                            </label>
                                          </div>
                                          <div
                                            className="col-md-3 align-content-end ps-0 pe-2"
                                            id="assetFormLabel"
                                          >
                                            <MuiPickersUtilsProvider
                                              utils={DateFnsUtils}
                                            >
                                              <ThemeProvider
                                                theme={materialTheme}
                                              >
                                                <DatePicker
                                                  value={this.state.startDate}
                                                  variant="outlined"
                                                  fullWidth
                                                  size="small"
                                                  inputVariant="outlined"
                                                  // timeinputlabel="Time:"
                                                  maxDate={new Date()}
                                                  format="MM/dd/yyyy"
                                                  style={{
                                                    background: "#fff",
                                                  }}
                                                  onChange={this.handleStartDateChange.bind(
                                                    this
                                                  )}
                                                  helperText={
                                                    this.state.errorMassage
                                                      ? "Start Date is Required"
                                                      : ""
                                                  }
                                                  error={
                                                    this.state.errorMassage
                                                  }
                                                  InputProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment position="end">
                                                        <IconButton style={{ marginBottom: "5px" }}>
                                                          <span className="picker-icon">📅</span>
                                                        </IconButton>
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                />
                                              </ThemeProvider>
                                            </MuiPickersUtilsProvider>
                                          </div>
                                          <div className="align-self-center p-0 mb-1" style={{ width: "28px" }}>
                                            thru
                                          </div>
                                          <div
                                            className="col-md-3 align-content-end pe-0 ps-2"
                                            id="assetFormLabel"
                                          >
                                            <MuiPickersUtilsProvider
                                              utils={DateFnsUtils}
                                            >
                                              <ThemeProvider
                                                theme={materialTheme}
                                              >
                                                <DatePicker
                                                  value={this.state.endDate}
                                                  variant="outlined"
                                                  fullWidth
                                                  size="small"
                                                  inputVariant="outlined"
                                                  format="MM/dd/yyyy"
                                                  style={{
                                                    background: "#fff",
                                                  }}
                                                  onChange={this.handleEndDateChange.bind(
                                                    this
                                                  )}
                                                  helperText={
                                                    this.state.errorMassage
                                                      ? "Start Date is Required"
                                                      : ""
                                                  }
                                                  error={
                                                    this.state.errorMassage
                                                  }
                                                  maxDate={
                                                    new Date(
                                                      new Date().getFullYear(),
                                                      new Date().getMonth() + 1,
                                                      0
                                                    )
                                                  }
                                                  InputProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment position="end">
                                                        <IconButton style={{ marginBottom: "5px" }}>
                                                          <span className="picker-icon">📅</span>
                                                        </IconButton>
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                />
                                              </ThemeProvider>
                                            </MuiPickersUtilsProvider>
                                          </div>
                                          <div className="col-md-2">
                                            <Button
                                              id="ptsButton"
                                              type="submit"
                                            >
                                              Apply
                                            </Button>
                                          </div>
                                        </div>
                                      </ValidatorForm>
                                    )}
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-12 row d-flex">
                    <div
                      className="text-start"
                      id="areaChart"
                      style={{ padding: "0.5em 1em" }}
                    >
                      {this.state.dailyMessageOptions !== null &&
                        this.state.dailyMessageSeries !== null ? (
                        <ReactApexCharts
                          options={this.state.dailyMessageOptions}
                          series={this.state.dailyMessageSeries}
                          type="area"
                          height={250}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Menu
            anchorEl={this.state.anchorEl}
            id="dropdown-menu"
            className="filterDropdownMenu"
            open={this.state.open}
            onClose={this.handleAccountDropdownClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 20,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <div
              className="dropdown-item"
              style={{ cursor: "pointer", width: "300px", height: "100%" }}
            >
              <div className="row">
                <h5 id="headerLabel">Date range</h5>
                <div className="col-md-12 mt-2" id="assetFormLabel">
                  <div className="row">
                    <div
                      className="col-md-6 dateTimePicker"
                      id="assetFormLabel"
                    >
                      <label
                        className="form-label "
                      // htmlFor="collapsible-companyName"
                      >
                        Start
                      </label>
                      <br />
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <ThemeProvider theme={materialTheme}>
                          <DatePicker
                            clearable
                            value={this.state.startDate}
                            // variant="inline"
                            margin="normal"
                            fullWidth
                            variant="outlined"
                            id="ptsDateTimePicker"
                            inputVariant="outlined"
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            onChange={this.handleStartDateChange.bind(this)}
                            helperText={
                              this.state.errorMassage
                                ? "Start Date is Required"
                                : ""
                            }
                            error={this.state.errorMassage}
                          />
                        </ThemeProvider>
                      </MuiPickersUtilsProvider>
                    </div>
                    <div
                      className="col-md-6 dateTimePicker"
                      id="assetFormLabel"
                    >
                      <label
                        className="form-label "
                        htmlFor="collapsible-companyName"
                      >
                        End
                      </label>{" "}
                      <br />
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <ThemeProvider theme={materialTheme}>
                          <DatePicker
                            clearable
                            value={this.state.endDate}
                            // variant="inline"
                            margin="normal"
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            variant="outlined"
                            id="ptsDateTimePicker"
                            inputVariant="outlined"
                            onChange={this.handleEndDateChange.bind(this)}
                            helperText={
                              this.state.endDateErrorMassage
                                ? "End Date is Required"
                                : ""
                            }
                            error={this.state.endDateErrorMassage}
                          />
                        </ThemeProvider>
                      </MuiPickersUtilsProvider>
                    </div>
                    {this.state.error ? (
                      <lable className="errorMassageShow">
                        End Date should be after Start Date
                      </lable>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-md-12 mt-4 text-end">
                  {/* <CancelIconButton onClick={this.handleAccountDropdownClose} /> */}
                  <button
                    className="fileterCancelButton"
                    onClick={this.handleAccountDropdownClose}
                  >
                    Cancel
                  </button>{" "}
                  &nbsp; &nbsp;
                  <button
                    className="fileterButton"
                    onClick={(e) => this.filterRecords(e)}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </Menu>
          {
            this.accountSettings?.enablePaymentIntegration && (
              <div
                className="materialTable paymentShortLinkClick mt-4"
                style={{ width: "100%" }}
              >
                <MaterialTable
                  title={
                    <span className="me-4 cardSub-hedding">
                      Payment Short-link Clicks
                    </span>
                  }
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    // {
                    //   title: "#",
                    //   render: (rowData) => rowData.tableData.id + 1,
                    //   width: "5%",
                    //   align: "left",
                    //   cellStyle: {
                    //     width: "6%",
                    //   },
                    // },
                    {
                      title: "Message Title",
                      field: "title",
                      cellStyle: {
                        width: "25%",
                        textTransform: "none",
                      },
                    },
                    {
                      title: "Text",
                      field: "textMessage",
                      cellStyle: {
                        width: "50%",
                        textTransform: "none",
                      },
                    },
                    {
                      title: "# of Clicks",
                      field: "clickCount",
                      render: (rowData) => {
                        return (
                          <>
                            <span
                              className="anchortag"
                              onClick={(e) => this.handleOpen(e, rowData)}
                            >
                              {rowData.clickCount}
                            </span>
                          </>
                        );
                      },
                      cellStyle: {
                        width: "12%",
                      },
                    },
                  ]}
                  data={this.state.messageWiseClickCount}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isMessagePaging,
                  }}
                  onChangePage={(page, pageSize) => {
                    this.handleMaterialTablePageChange(page, pageSize);
                  }}
                />
              </div>
            )
          }
          <div className="row mt-4">
            <div className="col md-12">
              <div className="card rounded-0" style={{ padding: "0px 28px" }}>
                <div
                  className="row justify-content-between"
                  style={{ padding: "0.6em 0.8rem" }}
                >
                  <div className="d-flex col-12 col-lg-5 col-xl-5">
                    <div className="col-12 text-start totalResults align-self-center">
                      <span className="me-4">Short-link Clicks</span>
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end pe-2">
                    <span className="me-4 totalResults">
                      Total Links: {this.state.totalRecords}
                    </span>
                    <TextField
                      id="standard-search"
                      placeholder="Search"
                      type="text"
                      variant="standard"
                      style={{ width: "205px" }}
                      value={this.state.searchText}
                      onChange={this.onSearchChange.bind(this)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="MuiSvgIcon-fontSizeSmall"
                              onClick={this.getDashboardDetails.bind(
                                this,
                                0,
                                this.state.pageSize
                              )}
                            >
                              <SearchIcon
                                style={{ fontSize: "1.25rem", color: "353538" }}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                this.setState({ searchText: "" }, () => {
                                  this.getDashboardDetails(
                                    0,
                                    this.state.pageSize
                                  );
                                });
                              }}
                              disabled={!this.state.searchText}
                            >
                              <ClearIcon
                                style={{
                                  opacity: this.state.searchText ? 1 : 0.4,
                                  fontSize: "1.25rem",
                                  color: "353538",
                                }}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="table-responsive paginationTable">
                  <table className="table text-start table-hover">
                    <thead className="paginationTableThead">
                      <tr>
                        <th className="col fw-bold">Date Created</th>
                        <th className="col fw-bold">Target Page</th>
                        <th className="col fw-bold">Short Link</th>
                        <th className="col fw-bold"># of Clicks</th>
                        {/* <th className="col fw-bold">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.shortLinkList?.map((rowData, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor:
                              rowData.id === this.state.messageId
                                ? "#e6effc"
                                : "",
                          }}
                        >
                          <td style={{ width: "120px" }}>
                            {rowData.createdon}
                          </td>
                          <td style={{ width: "400px" }}>
                            <a
                              href={rowData.sourceLink}
                              target="_blank"
                              className="anchortag"
                              rel="noreferrer"
                            >
                              {Utils.truncateString(rowData.sourceLink, 50)}
                            </a>
                          </td>
                          <td style={{ width: "320px" }}>
                            {/* {" "}
                                   <a
                                     href={rowData.targetLink}
                                     target="_blank"
                                     className="anchortag fw-bold"
                                   > */}
                            {Utils.truncateString(rowData.targetLink, 50)}
                            {/* </a> */}
                          </td>
                          <td style={{ width: "120px" }}>{rowData.count}</td>
                          {/* <td style={{ width: "120px" }}>
                            {this.showActionButton(rowData)}
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {this.state.totalRecords === 0 && (
                  <div
                    className="row text-center"
                    style={{ padding: "6px 20px" }}
                  >
                    <h5 className="dataNotAvailable">No data found.</h5>
                  </div>
                )}
                {this.state.totalRecords > this.state.pageSize && (
                  <div className="row justify-content-between pagination p-1">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="pageSize col-12 text-start">
                        Page {this.state.pageNo + 1} of {this.state.totalPages}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        <Pagination
                          showPerPage={this.state.showPerPage}
                          pageNo={this.state.pageNo}
                          onPaginationChange={this.onPaginationChange.bind(
                            this
                          )}
                          total={this.state.totalRecords}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <PaymentShortLinkDialog
            ref={this.paymentShortLinkDialogueRef}
            style={{ float: "right" }}
          />
        </>
      );
    }
  }
}
export default Dashboard;
